import { Stack, Typography } from "@mui/material";
import { FC, memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { text, background, divider } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";
import { AppRoutes } from "@/routes/config";
import { TMockExamAttempt } from "@/infrastructure/adapters/mock-exam/mock-exam.types";
import { formatSecondsToTime } from "@/features/mock-exam/utils/time";

const HistoryItem: FC<{ item: TMockExamAttempt }> = memo(({ item }) => {
  const { t } = useTranslation();

  return (
    <Stack
      component={Link}
      to={AppRoutes.mockExamResult.replace(":attemptId", String(item.attemptId))}
      state={{ fromHistory: true }}
      direction="row"
      alignItems="flex-end"
      px={spacing.smd}
      py={spacing.xs}
      borderRadius={rounded.xs}
      border={`1px solid ${divider.high}`}
      bgcolor={background.white}
    >
      <Stack flexGrow={1} gap={spacing.xxs}>
        {/* Date */}
        <Typography variant="cap12" color={text.secondary}>
          {item.date}
        </Typography>

        {/* Grade + score ... time */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={spacing.xs}>
          <Typography variant="body14Bold" color={text.primary}>
            {t("mockExam.history.result", {
              grade: t("mockExam.grade.label", { grade: item.grade }),
              percent: item.scorePercentage,
              correct: item.correctAnswers,
              total: item.totalQuestions,
            })}
          </Typography>
          <Typography variant="cap12" color={text.secondary} noWrap>
            {t("mockExam.history.time", { time: formatSecondsToTime(item.timeSpentSeconds) })}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
});

HistoryItem.displayName = "HistoryItem";

export { HistoryItem };
